export const config = {
  teleportal: {
    env: 'https://se-azgb-tp-prfun01.azurewebsites.net',
    file: {
      Create: '/api/CreateFileAsync',
      Delete: '/api/DeleteFileAsync',
      get: '/api/GetFileAsync',
      list: '/api/GetAllAsync',
      delete: '/api/DeleteRecordAsync'
    },
    lookup: {
      get: '/api/GetAllAsync'
    },
    submitForm: {
      Create: '/api/CreateRecordAsync',
      Update: '/api/UpdateRecordAsync',
      get: '/api/GetAllAsync',
      getId: '/api/GetRecordByIdAsync',
      delete: '/api/DeleteRecordAsync',
      search: '/api/SearchRecordAsync'
    },
    profile: {
      get: '/api/ProfileAsync'
    },
    sonicForm: {
      get: '/api/GetFormSchemaAsync'
    },
    preferences: {
      get: '/api/GetPreferencesAsync',
      update: '/api/UpdatePreferencesAsync'
    },
    letter: {
      create: '/api/CaseCreationAsync'
    },
    order: {
      create: '/api/OrderCreationAsync'
    },
    custom: {
      fetch: '/api/ApplicationFormListAsync'
    },
    mentoring: {
      listTopicsFromContacts: '/api/ListTopicsfromContactsAsync?code=8q005O3OCNzvvChljO7QYRYVkoXA8dQOwcXt28F-dfUAAzFuvpvevg==',
      listTopicsFromMentees: '/api/ListTopicsfromMenteesAsync?Code=c8GUkPhJNfq61UyzHcDx-9djFvZymnOSnkGj-SH4PV8ZAzFu0opzSA=='
    }
  },
  entitlement: {
    env: 'https://se-azgb-etl-prfun01.azurewebsites.net',
    entitle: {
      getContactEntitle:
        '/api/GetContactEntitlementAsync?',
      getEntitle:
        '/api/GetEntitlementAsync?'
    }
  },
  publicAPI: {
    env: 'https://se-azgb-tp-prfun04.azurewebsites.net',
    firmDirectory:
      'https://se-azgb-tp-prfun04.azurewebsites.net/api/GetPublicMemberFirmDirectoryAsync?&recordtype=account',
    memberDirectory:
      'https://se-azgb-tp-prfun04.azurewebsites.net/api/GetPublicMemberFirmDirectoryAsync?&recordtype=contact',
    employeeSearch: 'https://se-azgb-tp-prfun04.azurewebsites.net/api/SearchRecordAsync',
    createProfileRequest: 'https://se-azgb-tp-prfun04.azurewebsites.net/api/CreateRecordForProfileRequestAsync',
    getIdentityRecord:
      'https://se-azgb-tp-prfun04.azurewebsites.net/api/GetIdentityRecordAsync'
  },
  sonicwebform: {
    env: 'https://se-azgb-swf-prfun02.azurewebsites.net',
    getFormschema: '/api/GetFormSchemaAsync',
    createFormsubmit: '/api/CreateFormSubmissionAsync',
    getFormsubmit: '/api/GetFormSubmissionAsync',
    cancelFormsubmit: '/api/CancelFormSubmissionAsync'
  },
  payment: {
    env: 'https://se-azgb-tp-prfun03.azurewebsites.net',
    orderDetails: '/api/OrderDetailsAsync',
    payHandler: '/api/InitiateTransactionAsync',
    processTransactionSync: '/api/ProcessTransationAsync',
    queryTransactionSync: '/api/QueryTransactionAsync',
    returnUrl: 'https://se-azgb-tp-prfun03.azurewebsites.net/api/Redirect',
    initiateTrans: 'https://secure.paygate.co.za/payweb3/initiate.trans',
    payGateProcessTransactionSync:
      'https://secure.paygate.co.za/payweb3/process.trans',
    payGateQueryTransaction: 'https://secure.paygate.co.za/payweb3/query.trans'
  },
  blob: {
    env: 'https://seazgbtpteasa02.blob.core.windows.net'
  }
}
